export default {
  paywall: {
    actions: {
      notNow: "Ahora no",
      noThanks: "No, gracias",
      skip: "Omitir",
    },
    generic: {
      title: "Desbloquea la experiencia completa",
      subtitle: "Accede a todo lo que necesitas para investigar, construir y realizar apuestas mas inteligentes",
      whyJoin: "Por que unirse a Linemate+?",
      comparePlans: "Comparar planes",
      renewalDisclaimer: "El plan se renueva automaticamente. Cancela cuando quieras.",
    },
    sources: {
      injuryImpact: {
        title: "Desbloquea Impacto de lesiones",
        subtitle: "Mira como las lesiones impactan a sus companeros.\nProfundiza en cada tendencia",
      },
      startingLineups: {
        title: "Desbloquea Alineaciones titulares",
        subtitle: "Encuentra valor cuando cambian las alineaciones titulares.\nProfundiza en cada tendencia",
      },
      opponentRank: {
        title: "Desbloquea Ranking defensivo del rival",
        subtitle: "Aprovecha enfrentamientos defensivos favorables.\nProfundiza en cada tendencia",
      },
      weatherReport: {
        title: "Desbloquea Reporte del clima",
        subtitle: "Usa el viento y el clima a tu favor.\nProfundiza en cada tendencia",
      },
      startingPitchers: {
        title: "Desbloquea Lanzadores abridores rivales",
        subtitle: "Apunta a spots contra lanzadores vulnerables.\nProfundiza en cada tendencia",
      },
    },
    features: {
      injuryImpact: {
        title: "Impacto de lesiones",
        description: "Mira como las lesiones impactan a sus companeros.",
      },
      startingLineups: {
        title: "Alineaciones titulares",
        description: "Encuentra valor cuando cambian las alineaciones titulares.",
      },
      opponentRank: {
        title: "Ranking defensivo del rival",
        description: "Aprovecha enfrentamientos defensivos favorables.",
      },
      weatherReport: {
        title: "Reporte del clima",
        description: "Usa el viento y el clima a tu favor.",
      },
      startingPitchers: {
        title: "Lanzadores abridores rivales",
        description: "Apunta a spots contra lanzadores vulnerables.",
      },
    },
    comparison: {
      title: "Funciones",
      free: "Gratis",
      rows: {
        dailyTeamAndPlayerTrends: "Tendencias diarias de equipos y jugadores",
        dailyParlayTrends: "Tendencias diarias de parlays",
        teamAndPlayerPropsTool: "Herramienta de props de equipos y jugadores",
        statsAndStandings: "Estadisticas y clasificaciones",
        dailyCheatsheets: "Cheatsheets diarios",
        advancedSignalsAndTools: "Senales y herramientas avanzadas",
        startingLineups: "Alineaciones titulares",
        injuryImpact: "Impacto de lesiones",
        opponentDefensiveRank: "Ranking defensivo del rival",
        weatherReports: "Reportes del clima",
        startingOpponentPitchers: "Lanzadores abridores rivales",
      },
    },
    plans: {
      bestValue: "Mejor valor",
      annual: "Anual",
      monthly: "Mensual",
      yearlyPlan: "Plan anual",
      monthlyPlan: "Plan mensual",
      perYearShort: "ano",
      perMonthShort: "mes",
    },
    onboarding: {
      trialTitle: "Comienza tu prueba gratis de 7 dias",
      trialSubtitle: "Elige un plan para continuar cuando termine tu prueba",
    },
    cta: {
      claimYourCode: "Canjea tu código",
      startYourFreeTrial: "Comienza tu prueba gratis",
      startMy7DayFreeTrial: "Comenzar mi prueba gratis de 7 dias",
      tryFreeAndSubscribe: "Probar gratis y suscribirse",
      upgradeToLinematePlus: "Mejorar a Linemate+",
    },
    trial: {
      sevenDaysFree: "7 dias gratis",
      thenPerMonth: "{{trial}}, luego {{price}} al mes",
      thenPerYear: "{{trial}}, luego {{price}} al ano ({{monthlyPrice}}/{{perMonthShort}})",
      startingOn: " a partir del {{date}}",
      standardPerMonth: "{{price}} al mes",
      standardPerYear: "{{price}} al ano ({{monthlyPrice}}/{{perMonthShort}})",
      subtitleSuffix: " con una prueba gratis de 7 dias.",
    },
  },
};
